import {IgenomicsState} from "@ispm/core/interfaces/genomics-state.interface";
import {createSelector} from "@ngrx/store";
import * as _ from 'lodash'


const selectAdvancedSearchFeature = (state: IgenomicsState) => state.advancedSearch;

export const advancedSearchConfigurationSelector =
  createSelector(selectAdvancedSearchFeature, selectAdvancedSearchFeature =>
    _.cloneDeep(selectAdvancedSearchFeature.configuration))
